import { Permissions } from '../../../../../shared/utils/access-control/enums/permissions';
import { SequenceTab } from '../../../enums';
import { SequenceStatsCounts } from '../../../types';
import { SequenceTabType } from '../types';

export const getSequenceTabsCount = (
  key: SequenceTab,
  statsCounts: SequenceStatsCounts,
) => {
  switch (key) {
    case SequenceTab.Steps:
      return statsCounts?.stepCount;
    case SequenceTab.Prospects:
      return statsCounts?.prospectCount;
    case SequenceTab.Settings:
      return 0;
    case SequenceTab.Subsequence:
      return statsCounts?.subSequenceCount;
    default:
      return 0;
  }
};

export const getSequenceTabs = (): SequenceTabType[] => [
  {
    key: SequenceTab.Steps,
    label: 'Steps',
  },
  {
    key: SequenceTab.Prospects,
    label: 'Prospects',
    permission: Permissions.SEQUENCE_PROSPECT_READ,
  },
  {
    key: SequenceTab.Emails,
    label: 'Emails',
    permission: Permissions.SEQUENCE_EMAIL_READ,
  },
  {
    key: SequenceTab.Settings,
    label: 'Settings',
    permission: Permissions.SEQUENCE_SETTING_READ,
  },
  {
    key: SequenceTab.Subsequence,
    label: 'Subsequence',
    permission: Permissions.SUBSEQUENCE_SHOW,
  },
  {
    key: SequenceTab.SequenceScore,
    label: 'SequenceScore',
    permission: Permissions.SEQUENCE_SCORE_READ,
  },
];

export const formatNumber = (num: number) => {
  const absNum = Math.abs(num);

  let formatted;

  if (absNum >= 1_000_000_000) {
    formatted = `${(num / 1_000_000_000).toFixed(1)}B`;
  } else if (absNum >= 1_000_000) {
    formatted = `${(num / 1_000_000).toFixed(1)}M`;
  } else if (absNum >= 1_000) {
    formatted = `${(num / 1_000).toFixed(1)}K`;
  } else {
    return num.toString();
  }

  return formatted.replace(/\.0([KMB])$/, '$1');
};
